import Eye from 'components/Svg/Eye';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { companySelector } from 'store/company';
import { productsSelector, setPaymentDetails } from 'store/product';

import styles from 'styles/modules/Card.module.scss';

const EditingService = ({ id }) => {
    const dispatch = useDispatch();
    const router = useRouter();

    const { data } = useSelector(productsSelector);
    const { data: companyState } = useSelector(companySelector);

    const [companyData, setCompanyData] = useState({});
    const [paymentData, setPaymentData] = useState({});

    useEffect(() => {
        if (data?.proEdit) {
            const { prices, ...product } = data.proEdit;
            setPaymentData({ prices, product });
        }
    }, [data]);

    useEffect(() => {
        setCompanyData(companyState);
    }, [companyData]);

    const handleClick = async (e) => {
        e.preventDefault();
        const priceId =
            companyData.plan.type === 'free'
                ? process.env.STRIPE_PRICE_ID_PROEDIT_FREE
                : process.env.STRIPE_PRICE_ID_PROEDIT_PREMIUM;
        const price = paymentData.prices?.find((price) => price.id === priceId);
        dispatch(
            setPaymentDetails({
                product: paymentData.product,
                price: price,
                storyId: id,
            })
        );
        router.push({
            pathname: '/payments',
        });
    };

    return (
        <span
            className={[
                styles['card__status'],
                styles['card__status--request-editing'],
            ].join(' ')}
        >
            <Eye />
            Request&nbsp;
            <a href="#" onClick={handleClick}>
                editing service
            </a>
        </span>
    );
};

export default EditingService;
